import * as React from 'react'
import { store, persistor } from './store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import RootRouter from './router'
import "./style/main.less"
// import 'antd/dist/antd.less';

const Main = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
        <RootRouter />
    </PersistGate>
  </Provider>
)

export default Main
